/**
 * @file send-reset-email-view.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene la vista para enviar el correo de restablecimiento de contraseña
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-14
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { useCallback, useMemo, useState } from "react";
import { useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";

import SendResetMailPasswordForm from "../components/send-reset-mail-password-form";
import ResetPasswordForm from "../components/reset-password-form";
import ModalComponent from "@/components/modals/ModalComponent";
import ButtonComponent from "@/components/ui/ButtonComponent";
import { useRouter } from "@/features/i18n";

const SendResetEmailView = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const t = useTranslations("SendResetMail");
  const title = useTranslations("Title.ResetPassword");

  const token = useMemo(
    () => searchParams?.get("token") || "",
    [searchParams]
  );

  const [isEmailSentModalOpen, setIsEmailSentModalOpen] = useState(false);
  const [isPasswordChangedModalOpen, setIsPasswordChangedModalOpen] =
    useState(false);

  const handleEmailSuccess = useCallback(() => {
    setIsEmailSentModalOpen(true);
  }, []);

  const handlePasswordSuccess = useCallback(() => {
    setIsPasswordChangedModalOpen(true);
  }, []);

  const handleEmailSentModalClose = useCallback(() => {
    setIsEmailSentModalOpen(false);
  }, []);

  const handleNavigateToLogin = useCallback(() => {
    router.push("/login");
  }, [router]);

  return (
    <section className="auth__stack-center auth__send-reset-view">
      <h1 className="auth__title-primary">
        {token ? title("title") : t("title")}
      </h1>
      <p className="auth__send-reset-description">
        {token ? t("descriptionNewPassword") : t("description")}
      </p>

      {token ? (
        <ResetPasswordForm token={token} onSuccess={handlePasswordSuccess} />
      ) : (
        <SendResetMailPasswordForm onSuccess={handleEmailSuccess} />
      )}

      <ModalComponent
        title={t("modalLinkTitle")}
        isOpen={isEmailSentModalOpen}
        onClose={handleEmailSentModalClose}
        onConfirm={handleEmailSentModalClose}
        buttonConfirmText="buttonAccept"
      >
        <p>{t("modalLinkDescription")}</p>
      </ModalComponent>

      <ModalComponent
        title={t("modalPasswordTitle")}
        isOpen={isPasswordChangedModalOpen}
        onClose={handleNavigateToLogin}
        customButton={
          <ButtonComponent
            label="buttonLogin"
            onClick={handleNavigateToLogin}
            width="full"
          />
        }
      >
        <p>{t("modalPasswordDescription")}</p>
      </ModalComponent>
    </section>
  );
};

export default SendResetEmailView;
